export const FvmsApiMessage:any[] = [
    {"id":"error.unkown","content":"알 수 없는 오류"}
    
   ,{"id":"error.auth.id.not.exist","content":"id 를 찾을 수 없습니다"}
   ,{"id":"error.auth.password.not.exist","content":"password 값이 서버로 전송되지 않았습니다"}
   ,{"id":"error.auth.password.salt.not.exist","content":"password 확인중 오류가 발생했습니다. 시스템 관리자에게 문의하세요."}
   ,{"id":"error.auth.password.not.match","content":"password 가 일치하지 않습니다"}
   ,{"id":"error.auth.fail.count.over.max","content":"인증 실패 제한이 초과 되었습니다. 시스템 관리자에게 문의하세요."}
   ,{"id":"error.auth.token.invalid","content":"올바른 토큰이 아닙니다."}
   ,{"id":"error.auth.token.expired","content":"토큰이 만료되었습니다."}
   ,{"id":"error.auth.token.empty","content":"토큰이 없습니다."}

   ,{"id":"error.data.dupl","content":"중복된 데이터가 존재합니다."}
   ,{"id":"error.data.not.exist","content":"데이터가 존재하지 않습니다."}

]
